<template>
	<div class="foot-control">
		<div class="maincontent__double-header-wrapper">
			<div class="maincontent__double-header">
				<h2 class="maincontent__double-header-title">Sterownik nożny</h2>
				<h2 class="maincontent__double-header-unit unit-model-header">
					<small>Unit stomatologiczny</small><br />
					{{ unit.fullName }}
				</h2>
			</div>
		</div>
		<div class="foot-control__main">
			<h4 class="foot-control__main-header">Wybierz model sterownika</h4>
			<small class="foot-control__main-hint">Wybierz jedną opcję:</small>
			<div class="foot-control__options">
				<div class="foot-control__radios">
					<Radio
						class="foot-control__radio"
						v-for="(control, index) in controls"
						name="foot-control"
						:value="control.name"
						@change="handleFootControlChange"
						:checked="control.name === selectedControl"
						:key="`control__${index}`"
						multiple
					>
						<span class="foot-control__radio-label">
							{{ control.fullName }}
						</span>
						<span class="foot-control__radio-cost" slot="right-addon">
							{{ formatPrice(control.cost) }}
							<Tooltip v-if="control.tooltip_text" :text="control.tooltip_text" />
						</span>
					</Radio>
				</div>
				<div class="foot-control__preview">
					<img
						class="foot-control__image"
						v-if="controlImage"
						:src="require(`@/assets/pictures/${controlImage}`)"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as R from 'ramda';
import AppDataMixin from '@/mixins/app-data';
import Radio from '@/components/Radio';
import Tooltip from '../Tooltip';

export default {
	name: 'FootControl',
	components: {Radio, Tooltip},
	mixins: [AppDataMixin],
	data() {
		return {
			controls: [],
		};
	},
	computed: {
		controlImage() {
			return R.pipe(
				R.find(R.propEq('name', this.selectedControl)),
				R.propOr(null, 'image')
			)(this.controls);
		},
		selectedControl() {
			return this.$store.state.unitConfiguration.footControl;
		},
	},
	methods: {
		handleFootControlChange(control) {
			if (control) {
				this.$store.commit('unitConfiguration/setFootControl', control);
			}
		},
	},
	mounted() {
		this.controls = this.getAppData('footControlsList');
	},
};
</script>
